// transform: translateX(-500px);
// transition: transform ease-in-out .3s;

/**
 * @param slideContainer {HTMLElement}
 * @param controlsContainer {HTMLElement}
 * @constructor
 */
function FormSlider(slideContainer, controlsContainer) {
    this.slidesContainer = slideContainer;
    this.slidesLine = slideContainer.querySelector('.js-slider-line');
    this.slides = this.slidesLine.querySelectorAll('.js-slide');
    this.controlsContainer = controlsContainer;
    var self = this;
    this.next = this.controlsContainer.querySelector('.js-next');
    if (this.next) {
        this.next.addEventListener('click', function (e) {
            e.preventDefault();
            self.setStep(self.currentSlide + 1);
        });
    }
    this.prev = this.controlsContainer.querySelector('.js-prev');
    if (this.prev) {
        this.prev.addEventListener('click', function (e) {
            e.preventDefault();
            if (self.currentSlide > 0) {
                self.setStep(self.currentSlide - 1);
            }
        });
    }
    this.counter = this.controlsContainer.querySelector('.js-counter');
    this.currentSlide = 0;
}

FormSlider.prototype.init = function () {
    this.slidesLine.style.transition = 'transform ease-in-out .3s';
    this.setStep(0);
};

FormSlider.prototype.setStep = function (index) {
    this.currentSlide = index;
    this.controlsContainer.style.display = this.slides.length - 1 >= this.currentSlide + 1 ? '' : 'none';
    var width = 0;
    for (var i = 0; i < this.currentSlide; i++) {
        if (this.slides) {
            width += this.slides[i].clientWidth;
        }
    }
    if (this.currentSlide > 0) {
        this.prev.disabled = false;
    } else {
        this.prev.disabled = true;
    }
    this.slidesLine.style.transform = 'translateX(-' + width + 'px)';
    this.counter.textContent = (this.currentSlide + 1) + '/' + (this.slides.length - 1);
};
